import { useCallback, useRef } from 'react';

interface JitsiApi {
  executeCommand: (command: string, ...args: unknown[]) => void;
  addEventListener: (event: string, handler: () => void) => void;
  removeEventListener: (event: string, handler: () => void) => void;
}

interface UsePasswordProtectionProps {
  password: string | null;
  apiRef: React.MutableRefObject<JitsiApi | null>;
  onMeetingClose: () => void;
}

export const usePasswordProtection = ({ password, apiRef }: UsePasswordProtectionProps) => {
  const hasAttemptedAutoPasswordRef = useRef(false);

  const handlePasswordRequired = useCallback(() => {
    if (!apiRef.current) {
      return;
    }

    if (password && !hasAttemptedAutoPasswordRef.current) {
      hasAttemptedAutoPasswordRef.current = true;
      apiRef.current.executeCommand('password', password);
      return;
    }
  }, [apiRef, password]);

  const setupPasswordListener = useCallback(
    (api: JitsiApi) => {
      api.addEventListener('passwordRequired', handlePasswordRequired);
    },
    [handlePasswordRequired],
  );

  return {
    setupPasswordListener,
  };
};
